(function ($) {

    var $aChart = $('#availability_chart');
    var $aDatepicker = $('#availability_datepicker');
    var $aCheckInOut = $('#check_in_out');
    var $aCheckin = $('#a_checkin');
    var $aCheckout = $('#a_checkout');

    /**
     * Watch global reservation data
     * @since 2019-09-12
     */
    watch(TL.app.reservation, (prop, method, newValue, oldValue) => {
        switch (prop) {
            case 'propertyId':
                Update.accesscode(newValue)
                break;
            case 'checkin':
            case 'checkout':                
                Update.checkInOut(
                    TL.app.reservation.get('checkin'),
                    TL.app.reservation.get('checkout')
                )
                break;
            case 'numofroom':
                Update.numOfRoom(newValue)
                1 !== Number(newValue)
                    ? Update.multipleMode(true)
                    : Update.multipleMode(false)
                break;
            case 'numofadult':
                Update.numOfAdult(newValue)
                break;
            case 'numofchild':
                Update.numOfChild(newValue)
                break;
            case 'accesscode':
                Update.accesscode(newValue)
                break;
            default:;
        }
    })

    /**
     * Update methods
     * @since 2019-09-13
     */
    const Update = {
        propertyId(value) {
            $('#a_propertyid').val(value)
        },
        checkInOut(checkin, checkout) {            
            var $aCheckInOut = $('#check_in_out')
            var $aCheckin = $('#a_checkin')
            var $aCheckout = $('#a_checkout')
            if (checkin && checkout) {
                // set date formatted
                let _ci = moment(checkin)
                let _co = moment(checkout)
                let checkinFormat = `${_ci.format('DD MMM')} ${TL.ui.localeYear(_ci.get('year'))}`
                let checkoutFormat = `${_co.format('DD MMM')} ${TL.ui.localeYear(_co.get('year'))}`
                $aCheckInOut.val(checkinFormat + ' - ' + checkoutFormat)
                // set value
                $aCheckin.val(_ci.format('YYYY-MM-DD'))
                $aCheckout.val(_co.format('YYYY-MM-DD'))
            }
        },
        numOfRoom(value) {
            $('#a_room').val(value).trigger('change')
        },
        numOfAdult(value) {
            $('#a_adult').val(value).trigger('change')
        },
        numOfChild(value) {
            $('#a_child').val(value).trigger('change')
        },
        numOfAll(room, adult, child) {
            this.numOfRoom(room)
            this.numOfAdult(adult)
            this.numOfChild(child)
        },
        accesscode(value) {
            $('#a_promo').val(value)
        },
        multipleMode(bool) {
            bool
                ? $aChart.addClass('-multiple-rooms')
                : $aChart.removeClass('-multiple-rooms')
        }
    }

    /**
     * Availability Panel
     * @since 2019-06-07
     */
    $(document).on('click', '.js-view-availability-panel', function (event) {        
        event.preventDefault();

        var source = event.currentTarget.hash || event.currentTarget.dataset.target;
        $.magnificPopup.open({
            type: 'inline',
            items: {
                src: source
            },
            mainClass: 'component-popup mfp-slide-up',
            removalDelay: 200,
            alignTop: true,
            callbacks: {
                open() {                                           
                    // Update fields from global API
                    Update.checkInOut(
                            reservationAPI.get('s_checkin'),
                            reservationAPI.get('s_checkout')
                            )
                    Update.numOfAll(
                            reservationAPI.get('s_numofroom'),
                            reservationAPI.get('s_numofadult'),
                            reservationAPI.get('s_numofchild')
                            )
                    Update.accesscode(reservationAPI.get('s_accesscode'))
                    Update.propertyId(reservationAPI.get('propertyId'))

                    ac.setRange(new Date(reservationAPI.get('s_checkin')),new Date(reservationAPI.get('s_checkout')));
                    ac.init()

                    // Bind submit.a_form event for update global API data
                    $('#availability_form').on('submit.a_form', event => {
                        event.preventDefault();
                        var data = $(event.currentTarget).serializeArray();
                        var dataObj = {};
                        data.forEach(function (el) {
                            dataObj[el.name] = el.value
                        })
                        TL.app.reservation.set('s_checkin', dataObj.a_checkin)
                        TL.app.reservation.set('s_checkout', dataObj.a_checkout)
                        TL.app.reservation.set('s_numofroom', dataObj.a_room)
                        TL.app.reservation.set('s_numofadult', dataObj.a_adult)
                        TL.app.reservation.set('s_numofchild', dataObj.a_child)
                        TL.app.reservation.set('s_accesscode', dataObj.a_promo)
                    })
                },
                close() {
                    // Remove submita._form event
                    $('#availability_form').off('submit.a_form');
                }
            }
        });
    });

    var is_buddhist = (lang) => {
        let language_codes = ['th']
        return language_codes.includes(lang);
    }

    /**
     * Availability Calendar
     * @since 2019-05
     */
    // ดึงข้อมูลจาก global
    var calendarAPI = TL.app.calendar;
    var reservationAPI = TL.app.reservation;

    // สร้าง Calendar สำหรับ Availability form
    var ac = new Calendar('#availability_datepicker', {
        minDate: new Date(localData.h_currentdate),
        buddhist: is_buddhist(localData.h_lang),
        weekDayName: moment.weekdaysMin(),
        monthName: moment.months(),
        navigation: {
            prevText: '<i class="far fa-arrow-left"></i>',
            nextText: '<i class="far fa-arrow-right"></i>',
        }
    });

    $aDatepicker.on('show.bs.collapse', function (event) {
        $(document).on('click.avd', function (event) {
            let excerpt = '.btn-day';
            if (
                !$(event.target).closest($aDatepicker).length &&
                !$(event.target).closest(excerpt).length
            ) {
                $aDatepicker.collapse('hide');
            }
        });

        $aDatepicker.on('ready', ev => {
            Update.checkInOut(
                moment(ac.checkin).format('YYYY-MM-DD'),
                moment(ac.checkout).format('YYYY-MM-DD')
            );
            $aDatepicker.collapse('hide');
        })
    });

    $aDatepicker.on('hide.bs.collapse', function () {
        $(document).off('click.avd');
    });

    function initPropertyDailyAvailability() {
        $('#availability_datepicker').on('render', ev => {
            var NA = window.ListNotAvailable
            if (NA) {
                for (var i = 0; i < NA.length; i++) {
                    let d = NA[i]
                    let $el = $('#availability_datepicker').find(`[data-date-format="${d}"]`);
                    $el.attr('disabled','disabled');
                    $el.parent().addClass(`${ac.className.isDisabled} ${ac.className.isDisabledDate}`)
                }
            }
        })
    }
    
    function initAvailabilityPanel() {
        ac.checkin = reservationAPI.get('s_checkin');
        ac.checkout = reservationAPI.get('s_checkout');        
        ac.weekDayName = moment.weekdaysMin();
        ac.monthName = moment.months();
        ac.buddhist = is_buddhist(localData.h_lang);
        
        $('#availability_datepicker').on('stateChange', ev => {
            if ('ready' ===  ev.detail) {
                Update.checkInOut(
                    moment(ac.checkin).format('YYYY-MM-DD'),
                    moment(ac.checkout).format('YYYY-MM-DD')
                );
                $(ev.currentTarget).collapse('hide');
            }
        })
        
        initPropertyDailyAvailability()
        
        $('#a_room').on('change', function () {
            1 !== Number(this.value)
                    ? Update.multipleMode(true)
                    : Update.multipleMode(false)
        });
        
        ac.init(true)
    }
    
    if ('undefined' === typeof window.InitAvailabilityPanel) {
        window.InitAvailabilityPanel = initAvailabilityPanel;
    }
    
})(jQuery);